export const FILTER_SINGLE = 'single';
export const FILTER_LIST = 'list';
export const FILTER_RANGE = 'range';

export default {
  FILTER_SINGLE,
  FILTER_LIST,
  FILTER_RANGE,
};
